module.exports = __webpack_public_path__ + "static/img/Winnie_2020.4086fc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bssp/Winnie_2020.jpg
// module id = 138
// module chunks = 2